import {
  faCircleCheck,
  faTriangleExclamation,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import classnames from 'classnames'
import * as React from 'react'
import DSButton from '~/design-system/Button'
import DSText from '~/design-system/DSText'
import {shadowStyleToClass} from '~/design-system/ShadowUtils'
import type {TToastType} from '~/redux/reducers/toast'
import styles from './styles.module.css'

export interface IDSToastProps {
  type: TToastType
  message: string
  onDismiss: () => void
  className?: string
}

const iconForType = {
  success: faCircleCheck,
  failure: faTriangleExclamation,
  plain: undefined,
} as const

/** Presentational single toast card — no timer or animation state; `ReduxToast` drives those. */
const DSToast = ({type, message, onDismiss, className}: IDSToastProps) => {
  const icon = iconForType[type]
  return (
    <div
      role={type === 'failure' ? 'alert' : 'status'}
      className={classnames(
        styles.toast,
        styles[type],
        shadowStyleToClass('white', false),
        className
      )}
    >
      {icon && <FontAwesomeIcon icon={icon} className={styles.icon} />}
      <DSText size="body-16" className={styles.message}>
        {message}
      </DSText>
      <DSButton
        buttonStyle="none"
        className={styles.dismiss}
        onClick={onDismiss}
        aria-label="Dismiss"
      >
        <FontAwesomeIcon icon={faXmark} />
      </DSButton>
    </div>
  )
}

export default DSToast
